import React from 'react';
import styled from 'styled-components';

import {
  ArrowWithTailIcon,
  FlexRow,
  formatHash,
  SvgIcon,
  Text,
} from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';

import { getRouteDetails, useCustomHistory } from '../../router/utils';
import { useTranslation } from 'react-i18next';
import { deriveSplitDataFromNamedKeyValue } from '../../domain';

const StyledFlexRow = styled(FlexRow)(({ theme }) => ({
  cursor: 'pointer',
  width: 'fit-content',
}));

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  color: theme.styleguideColors.contentBlue,
}));

/* eslint-disable-next-line */
export interface PrevPageHeaderProps {}

export function PrevPageHeader(props: PrevPageHeaderProps) {
  const history = useCustomHistory();
  const { t } = useTranslation();

  const { allowedGoBack, prevRouteMatch } = history.location.state || {};

  if (!allowedGoBack || prevRouteMatch == null) {
    return null;
  }

  const { name, params } = getRouteDetails(prevRouteMatch, t);

  const hash = params.publicKey || params.id || params.token_id || '';
  const { prefix, hash: hashWithoutPrefix } =
    deriveSplitDataFromNamedKeyValue(hash);

  const handleClick = (ev) => {
    ev.stopPropagation();
    history.goBack();
  };

  const handleKeyDown = (ev) => {
    if (ev.key === 'Enter') {
      handleClick(ev);
    }
  };

  return (
    <StyledFlexRow align="center" onClick={handleClick}>
      <StyledSvgIcon src={ArrowWithTailIcon} marginRight />
      <BodyText
        size={1}
        scale={'sm'}
        variation="blue"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {name}{' '}
        <Text monotype>
          {prefix}
          {formatHash(hashWithoutPrefix)}
        </Text>
      </BodyText>
    </StyledFlexRow>
  );
}

export default PrevPageHeader;
